import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthGuard implements CanActivate {
  
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): boolean {
    if (this.authService.isAuthenticated()) {
      return true;
    } else {
      // Redirect to the main page if the user is not authorized
      this.router.navigate(['/']);
      return false;
    }
  }
} 


// WEBPACK FOOTER //
// ./src/app/guards/auth.guard.ts